import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Popup } from 'semantic-ui-react';

import {
  DISABLED_REASONS,
  QUEUE_ACTION,
  QUEUE_STATUS,
  QUEUE_VIEW,
  ROW_ACTIONS,
  ROW_ACTION_LABELS,
} from '../../constants/onboardingQueue';

const ACTION_TEST_IDS = {
  [QUEUE_ACTION.ACTIVATE]: 'queue-action-activate',
  [QUEUE_ACTION.OPT_OUT]: 'queue-action-opt-out',
  [QUEUE_ACTION.EDIT_STATUS]: 'queue-action-edit-status',
  [QUEUE_ACTION.NOTES]: 'queue-action-notes',
};

const isDisabled = (action, status) => (
  status === QUEUE_STATUS.ACCEPTED
  && (action === QUEUE_ACTION.EDIT_STATUS || action === QUEUE_ACTION.ACTIVATE)
);

const RowActionMenu = ({ view, record, onAction }) => (
  <Dropdown
    icon='ellipsis horizontal'
    pointing='top right'
    className='no-pointer-dropdown'
    data-testid='queue-row-menu'
  >
    <Dropdown.Menu>
      {ROW_ACTIONS[view].map(action => {
        const disabled = isDisabled(action, record.status);
        const reason = disabled ? DISABLED_REASONS[action] : null;
        const testId = ACTION_TEST_IDS[action];
        const reasonId = `${testId}-reason-${record.flatRateOfferId}`;
        const label = ROW_ACTION_LABELS[action];

        return (
          <Dropdown.Item
            key={action}
            disabled={disabled}
            data-testid={testId}
            aria-label={reason ? label : undefined}
            aria-describedby={reason ? reasonId : undefined}
            onClick={disabled ? undefined : () => onAction(action, record)}
          >
            {reason ? (
              <Popup
                size='small'
                position='left center'
                mouseEnterDelay={0}
                content={reason}
                trigger={(
                  <span className='queue-disabled-item-label'>{label}</span>
                )}
              />
            ) : label}
            {reason && (
              <span
                id={reasonId}
                className='queue-visually-hidden'
                data-testid={`${testId}-reason`}
              >
                {reason}
              </span>
            )}
          </Dropdown.Item>
        );
      })}
    </Dropdown.Menu>
  </Dropdown>
);

RowActionMenu.propTypes = {
  view: PropTypes.oneOf(Object.values(QUEUE_VIEW)).isRequired,
  record: PropTypes.shape({
    status: PropTypes.string,
    flatRateOfferId: PropTypes.string,
  }).isRequired,
  onAction: PropTypes.func.isRequired,
};

export default RowActionMenu;
